module.exports = __webpack_public_path__ + "static/img/order-question-red.4ae1a545.svg";